import { User } from "react-netlify-identity";
import { NetlifyUser } from "../types/api/common";

export function isAdmin(user: User | NetlifyUser | undefined): boolean {
    return (user?.app_metadata?.roles || []).includes('admin');
}